import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Szállás igény részletei", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_CustomerOfferTable = _resolveComponent("CustomerOfferTable")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "12",
        md: "4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _createVNode(_component_v_spacer),
                  (!_ctx.canEdit)
                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                        key: 0,
                        location: "bottom"
                      }, {
                        activator: _withCtx(({ props: tooltipProps }) => [
                          _createElementVNode("span", _normalizeProps(_guardReactiveProps(tooltipProps)), [
                            _createVNode(_component_v_btn, {
                              color: "primary",
                              variant: "text",
                              size: "small",
                              "prepend-icon": "mdi-pencil",
                              disabled: true
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Módosítás ")
                              ]),
                              _: 1
                            })
                          ], 16)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_ctx.editBlockedReason), 1)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        color: "primary",
                        variant: "text",
                        size: "small",
                        "prepend-icon": "mdi-pencil",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('editInquiry')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Módosítás ")
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }),
              _createVNode(_component_v_container, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            "model-value": 
                  _ctx.formatPublicReference(
                    _ctx.props.accommodationInquiry.publicReference
                  )
                ,
                            label: "Referencia",
                            variant: "outlined",
                            readonly: ""
                          }, null, 8, ["model-value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            "model-value": _ctx.props.accommodationInquiry.costCenterName,
                            label: "Költséghely",
                            variant: "outlined",
                            readonly: ""
                          }, null, 8, ["model-value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        md: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            "model-value": _ctx.props.accommodationInquiry.userName,
                            label: "Felhasználó",
                            variant: "outlined",
                            readonly: ""
                          }, null, 8, ["model-value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { sm: "4" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.props.accommodationInquiry.area,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.props.accommodationInquiry.area) = $event)),
                            label: "Helység",
                            variant: "outlined",
                            readonly: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { sm: "4" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.props.accommodationInquiry.numberOfPeople,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.props.accommodationInquiry.numberOfPeople) = $event)),
                            label: "Létszám",
                            variant: "outlined",
                            readonly: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { sm: "4" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            "model-value": 
                  _ctx.inquiryStatusLabel(_ctx.props.accommodationInquiry.status)
                ,
                            label: "Státusz",
                            variant: "outlined",
                            readonly: ""
                          }, null, 8, ["model-value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.props.accommodationInquiry.from,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.props.accommodationInquiry.from) = $event)),
                            label: "Érkezés",
                            variant: "outlined",
                            readonly: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.props.accommodationInquiry.to,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.props.accommodationInquiry.to) = $event)),
                            label: "Távozás",
                            variant: "outlined",
                            readonly: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            "model-value": 
                  _ctx.placementTypeLabel(_ctx.props.accommodationInquiry.placementType)
                ,
                            label: "Elhelyezés",
                            variant: "outlined",
                            readonly: ""
                          }, null, 8, ["model-value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.props.accommodationInquiry.contactName,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.props.accommodationInquiry.contactName) = $event)),
                            label: "Kapcsolattartó neve",
                            variant: "outlined",
                            readonly: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _ctx.props.accommodationInquiry.contactPhone,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.props.accommodationInquiry.contactPhone) = $event)),
                            label: "Kapcsolattartó telefonszáma",
                            variant: "outlined",
                            readonly: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_textarea, {
                            modelValue: _ctx.props.accommodationInquiry.catering,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.props.accommodationInquiry.catering) = $event)),
                            label: "Ellátás",
                            variant: "outlined",
                            rows: "2",
                            readonly: "",
                            "hide-details": ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_textarea, {
                            modelValue: _ctx.props.accommodationInquiry.comment,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.props.accommodationInquiry.comment) = $event)),
                            label: "Komment",
                            variant: "outlined",
                            rows: "2",
                            readonly: "",
                            "hide-details": ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_col, {
        cols: "12",
        md: "8"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "offers-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(" Ajánlatok ")
                ]),
                _: 1
              }),
              (_ctx.props.accommodationInquiry.offerEntityDTOS.length > 0)
                ? (_openBlock(), _createBlock(_component_v_container, { key: 0 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.accommodationInquiry.offerEntityDTOS, (offer) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: offer.id
                        }, [
                          _createVNode(_component_CustomerOfferTable, {
                            offer: offer,
                            "can-accept": !_ctx.hasAcceptedOffer,
                            onAcceptOffer: _ctx.acceptOffer,
                            onDeclineOffer: _ctx.declineOffer
                          }, null, 8, ["offer", "can-accept", "onAcceptOffer", "onDeclineOffer"])
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_v_container, { key: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Még nincsenek ajánlatok ")
                    ]),
                    _: 1
                  })),
              _createVNode(_component_v_card_actions, { class: "pa-4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  (_ctx.hasBooking)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        color: "primary",
                        to: `/bookings/${_ctx.props.accommodationInquiry.publicReference}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Tovább a foglaláshoz ")
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}